import { Box, LinearProgress, LinearProgressProps, Stack, Typography, TypographyProps } from "@mui/material";
import { GridValidRowModel } from "@mui/x-data-grid-premium";
import { FC } from "react";
import { IngestStatus } from "../../../Pages/admin/Ingest/IngestIndex/IngestProcessing/ingest-processing";

export type TableCellIngestProgressBarProps = {
  data: GridValidRowModel;
};

const TableCellIngestProgressBar: FC<TableCellIngestProgressBarProps> = ({ data }) => {
  const progress = data.value;
  let textColor: TypographyProps["color"];
  let progressBarColor: LinearProgressProps["color"];
  switch (data.row["status"] as IngestStatus) {
    case "Created":
    case "Quality Check in progress":
    case "Running":
      textColor = "primary.text";
      progressBarColor = "primary";
      break;
    case "Pending QC":
    case "Waiting for Mezz Reference":
    case "Need check or editing":
      textColor = "warning.main";
      progressBarColor = "warning";
      break;
    case "Workflow Error":
    case "Rejected":
    case "Aborted":
    case "Unknown":
      textColor = "error.main";
      progressBarColor = "error";
      break;
    case "Accepted":
    case "Completed":
      textColor = "success.main";
      progressBarColor = "success";
      break;
  }

  return (
    <Stack direction="row" alignItems="center" spacing={0.5} color={textColor}>
      <Typography color={textColor} sx={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
        {progress}%
      </Typography>

      <Box sx={(theme) => ({ width: "60px", flexShrink: 0, ml: `${theme.spacing(1)} !important` })}>
        <LinearProgress sx={{ borderRadius: "2px" }} color={progressBarColor} variant="determinate" value={progress} />
      </Box>
    </Stack>
  );
};

export default TableCellIngestProgressBar;
